/** Laatst gebruikte elementcodes per gebouw (alleen op dit apparaat; gemak, geen data). */
const key = (buildingId: string) => `pw-recent-elements-${buildingId}`;

export function recentElements(buildingId: string): string[] {
  try {
    const v: unknown = JSON.parse(localStorage.getItem(key(buildingId)) ?? "[]");
    return Array.isArray(v) ? v.filter((x): x is string => typeof x === "string").slice(0, 5) : [];
  } catch {
    return [];
  }
}

export function rememberElement(buildingId: string, code: string | null) {
  if (!code) return;
  try {
    const list = [code, ...recentElements(buildingId).filter((c) => c !== code)].slice(0, 5);
    localStorage.setItem(key(buildingId), JSON.stringify(list));
  } catch {
    // Opslag niet beschikbaar (privévenster): niet erg.
  }
}
